import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import IconButton from "components/common/IconButton";
import MessageField from "views/components/messagelist/MessageField";
import CustomHighlighting from "views/components/highlighting/CustomHighlighting";
import HoverForHelp from "components/common/HoverForHelp";
import { isArrayValue } from "search/messageFieldValueHelper";
const Container = styled.div(
  ({ theme }) => `
  background-color: ${theme.colors.table.variant.danger};
  display: flex;
  padding: ${theme.spacings.xxs};
  border-radius: 3px;

  &:not(last-child) {
    margin-bottom: ${theme.spacings.xxs};
  }
`
);
const FieldsCol = styled.div(
  ({ theme }) => `
  padding: 2px;
  color: black;
  flex: 1;
  color: ${theme.colors.gray[30]};
`
);
const ActionsCol = styled.div`
  padding: 2px;
`;
const MatchDetail = styled.div(
  ({ theme }) => `
  font-size: ${theme.fonts.size.small};
  color: ${theme.colors.gray[40]};
`
);
const StyledHoverForHelp = styled((props) => /* @__PURE__ */ React.createElement(HoverForHelp, { ...props }))`
  margin: 3px 8px;
`;
const WatchlistIndicator = ({
  allowRemoval,
  title,
  watchlistName = void 0,
  matchedEntry = void 0,
  matchedViaRange = false,
  fieldName,
  fieldValue,
  realFieldType,
  onDelete,
  message
}) => {
  const isArrayFieldValue = isArrayValue(fieldValue);
  const { t } = useTranslation("enterprise_search");
  return /* @__PURE__ */ React.createElement(Container, { title }, /* @__PURE__ */ React.createElement(FieldsCol, null, /* @__PURE__ */ React.createElement(CustomHighlighting, { key: fieldName, field: fieldName, value: fieldValue }, /* @__PURE__ */ React.createElement(MessageField, { fieldName, fieldType: realFieldType, message, value: fieldValue })), /* @__PURE__ */ React.createElement(MatchDetail, null, t("watchlist_indicator.on_watchlist", { name: watchlistName != null ? watchlistName : title })), matchedViaRange && matchedEntry && /* @__PURE__ */ React.createElement(MatchDetail, null, t("watchlist_indicator.matched_range", { entry: matchedEntry }))), allowRemoval && !isArrayFieldValue && /* @__PURE__ */ React.createElement(ActionsCol, null, /* @__PURE__ */ React.createElement(IconButton, { name: "delete", onClick: onDelete, title: t("watchlist_indicator.remove_from", { title }) })), allowRemoval && isArrayFieldValue && /* @__PURE__ */ React.createElement(StyledHoverForHelp, { title: t("watchlist_indicator.deletion_not_possible") }, t("watchlist_indicator.array_explanation", { title })));
};
export default WatchlistIndicator;
